// extracted by mini-css-extract-plugin
export var parcelRow = "_ra-0";